const locale = $("html").attr("lang");

const claimsValidateRules = {
    customer_email: {
        email: true,
    },
    customer_post_code: {
        custom_post_code: true,
    },
    tax_num: {
        digits: true,
        minlength: 10,
        maxlength: 10,
    },
};

if (locale == "sk") {
    claimsValidateRules["org_num"] = {
        number: true,
        exactlength: 8,
    };

    claimsValidateRules["vat_num"] = {
        skVatNum: true,
    };
}

document.addEventListener("DOMContentLoaded", function () {
    $(".js-form-account-claim").validate({
        rules: claimsValidateRules,
        errorPlacement: function (error, element) {
            if (element.attr("type") && element.attr("type").match("checkbox")) {
                error.insertAfter(element.siblings("label"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function (form) {
            $(form).find('[type="submit"]').prop("disabled", true).addClass("is-loading");

            window.assignRecaptchaResponseToForm(form).then(function () {
                form.submit();
            });
        },
    });
});
